<script>
  import { translate } from "../../i18n/i18next.js";

  export let value

  /**
   * Provide either translationKey or text
   * @type {{
   *   disabled?: boolean,
   *   value: string,
   *   translationKey?: string,
   *   text?: string,
   * }[]}
   */
  export let options = []

  /**
   * If true, disable all options
   * @type {boolean}
   */
  export let disabled = false
  export let name
</script>

<div class="radio-group-container">
  {#each options as option}
    <label
      class:disabled={disabled || !!option.disabled}
    >
      <input
        type="radio"
        bind:group={value}
        disabled={disabled || !!option.disabled}
        checked={option.value === value}
        value={option.value}
        name={name}
      />
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="12" cy="12" r="9" stroke="#CCCCCC"/>
        {#if option.value === value}<circle cx="12" cy="12" r="6.5" fill="#00468F"/>{/if}
      </svg>
      <span class="label-text">
        {#if option.translationKey}
          {translate(option.translationKey)}
        {:else}
          {option.text}
        {/if}
      </span>
    </label>
  {/each}
</div>

<style>
  label {
    display: inline-flex;
    align-items: center;
    cursor: pointer;
  }

  label.disabled {
    filter: opacity(0.5);
    cursor: default;
  }

  input {
    display: none;
  }

  .label-text {
    margin-left: 8px;
  }

  .radio-group-container {
    font-size: 16px;
    display: inline-flex;
    gap: 1rem;
  }
</style>